import Seo from "../components/Seo";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import LastUpdated from "../components/LastUpdated";
import ServicesSplit from "../components/ServicesSplit";
import XeriscapeFeature from "../components/XeriscapeFeature";
import Portfolio from "../components/Portfolio";
import ServiceAreaSection from "../components/ServiceAreaSection";
import Reviews from "../components/Reviews";
import BlogFeed from "../components/BlogFeed";
import FAQ from "../components/FAQ";
import ContactForm from "../components/ContactForm";
import { PAGE_UPDATED, webPageLd } from "../data/site";

export default function HomePage() {
  return (
    <>
      <Seo
        title="Concrete & Landscaping Austin TX | Texan Strong Builds"
        description="Premium concrete patios, stamped concrete, driveways, concrete repair and xeriscape landscaping in Austin TX. Free estimates. Call (512) 781-8851."
        canonical={`${window.location.origin}/`}
        jsonLd={webPageLd({
          name: "Concrete & Landscape Contractor Austin TX | Texan Strong Builds",
          path: "/",
          updated: PAGE_UPDATED.home,
          description: "Premium concrete patios, stamped concrete, driveways, concrete repair and xeriscape landscaping in Austin TX.",
        })}
      />
      <Hero />
      <TrustBar />
      <div className="bg-stone-50 border-b border-stone-200 py-2.5 text-center">
        <LastUpdated date={PAGE_UPDATED.home} />
      </div>
      <ServicesSplit />
      <XeriscapeFeature />
      <Portfolio />
      <ServiceAreaSection />
      <Reviews />
      <BlogFeed />
      <FAQ />
      <ContactForm />
    </>
  );
}
